import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withFormsy } from 'formsy-react';
import classNames from 'classnames';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

class Textarea extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    titleVisibility: PropTypes.bool,
    large: PropTypes.bool,
    autofocus: PropTypes.bool,
    className: PropTypes.string,
    maxLength: PropTypes.string,
    rows: PropTypes.number,
    intl: intlShape.isRequired,

    // formsy:
    setValue: PropTypes.func.isRequired,
    getValue: PropTypes.func.isRequired,
    showRequired: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    getErrorMessage: PropTypes.func.isRequired,
    isFormSubmitted: PropTypes.func.isRequired,
  }

  state = {
    canDisplayError: false,
  }
  componentDidMount() {
    if (this.props.rows) {
      this.onKeyUp(this.textarea);
    }
    // this.textarea.style.height = (2 + this.textarea.scrollHeight) + 'px';
  }

  onKeyUp = (event) => {
    const el = event.currentTarget ? event.currentTarget : event;
    el.style.height = '32px';
    el.style.height = (2 + el.scrollHeight) + 'px';
  }

  changeValue = (event) => {
    this.props.setValue(event.currentTarget.value);
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  displayError = (event) => {
    this.setState({
      canDisplayError: true,
    });
    this.changeValue(event);
  }

  render() {
    const isRequired = this.props.showRequired();
    const className = classNames('Form-textarea', {
      required: isRequired,
      error: !isRequired && this.props.showError(),
    }, this.props.className);

    const errorMessage = this.props.getErrorMessage() || (isRequired && this.props.isFormSubmitted() ? 'field_required' : null);

    return (
      <div className={className}>
        <label htmlFor={this.props.name} className={this.props.titleVisibility ? null : 'u-hiddenVisually'}>
          <FormattedMessage id={this.props.title} />
        </label>
        <textarea
          ref={ref => this.textarea = ref}
          className={classNames('Form-field', (this.props.large) ? 'Form-field--large' : null)}
          name={this.props.name}
          disabled = {this.props.disabled ? 'disabled' : null}
          onChange={this.changeValue}
          onBlur={this.displayError}
          placeholder={this.props.intl.formatMessage({id: this.props.title})}
          autoFocus={this.props.autofocus}
          value={this.props.getValue()}
          rows={this.props.rows}
          onKeyUp={this.onKeyUp}
          maxLength={this.props.maxLength}/>
        {(this.state.canDisplayError || this.props.isFormSubmitted()) && errorMessage ? (<div className="Form-error"><FormattedMessage id={errorMessage} /></div>) : null}
      </div>
    );
  }
}

export default injectIntl(withFormsy(Textarea), {withRef: true});



// WEBPACK FOOTER //
// ./src/components/Textarea/Textarea.js